var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodiumFirstBase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 80 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7460",
    d: "M5 5V0H75V5H80V127H0V5H5Z",
    fill: "var(--fill-0, #FFBC2B)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodiumFirstBase);
export default __webpack_public_path__ + "static/media/podium-first-base.5c4e3d708cacb570a6f3f2755f0ab2f4.svg";
export { ForwardRef as ReactComponent };